var _style, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewInstasignLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 280 70",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .insta {\n      font-family: Arial, sans-serif; \n      font-weight: bold; \n      font-size: 45px;\n      fill: #0084ff;\n    }\n    .sign {\n      font-family: Arial, sans-serif; \n      font-weight: bold; \n      font-size: 45px;\n      fill: #002864;\n    }\n  ")), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 50,
    className: "insta"
  }, "Insta")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 112,
    y: 50,
    className: "sign"
  }, "sign")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewInstasignLogo);
export default __webpack_public_path__ + "static/media/new_instasign_logo.8b83edd15c1d6809b26db59f0448f207.svg";
export { ForwardRef as ReactComponent };